import React, {useEffect, useState} from 'react'
import {getTitle, registerTitleSetCallback} from '../../../shared/audio/title'

export function RollingTitle() {
    const [displayTitle, setDisplayTitle] = useState(() => getTitle())
    useEffect(() => {
        registerTitleSetCallback(setDisplayTitle)
        return () => registerTitleSetCallback(null)
    }, [])
    return <React.Fragment>{displayTitle}</React.Fragment>
}
